// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputsMobileSection_wrapper__LtONE","inputEnterJob":"InputsMobileSection_inputEnterJob___wJn2","searchButton":"InputsMobileSection_searchButton__55o2D"};